import request from '@/utils/request'
import qs from 'qs'
import {getCookie} from '@/utils/cookiejs'

// 获取字典数据下拉框列表
export function getDictionaryDataSelector(dictionaryTypeId) {
  return request({
    url: `/api/system/DictionaryData/${dictionaryTypeId}/Data/Selector`,
    method: 'GET',
	headers: {
		'Authorization':getCookie('token')
	}
  })
}

// 获取国家下拉框列表
export function GetCountry() {
  return request({
    url: `/api/base/Country/GetAll`,
    method: 'GET',
	headers: {
		'Authorization':getCookie('token')
	}
  })
}

// 获取默认收款银行信息
export function GetDefaultBank() {
  return request({
    url: `/api/fin/BankAccount/Default`,
    method: 'GET',
	headers: {
		'Authorization':getCookie('token')
	}
  })
}

// 获取系统配置
export function GetSysConfig() {
  return request({
    url: `/api/webapi/config/info`,
    method: 'GET'
  })
}